import { gql } from "@apollo/client";

export const INDICATORS_CATALOG_QUERY = gql`
  query IndicatorsCatalog(
    $filters: IndicatorCatalogFilters
    $first: Int
    $offset: Int
    $sort: String
  ) {
    indicatorSummary(filters: $filters) {
      totalCount
      withDataCount
      withoutDataCount
      coverageRatio
      serviceCount
      territoryCount
      toValidateCount
      lastUpdatedAt
    }
    indicatorFilterOptions {
      services {
        id
        libelle
        categorie
        prioritaire
      }
      categories
      units
      frequencies
      sources
      territories {
        id
        kind
        label
      }
      dataAvailabilities
      statuses
    }
    indicatorCatalog(filters: $filters, first: $first, offset: $offset, sort: $sort) {
      totalCount
      nodes {
        id
        code
        libelle
        description
        serviceId
        serviceLibelle
        categorie
        unite
        frequence
        dataAvailability
        measureCount
        territoryCount
        periodMin
        periodMax
        quality
        status
        source
      }
    }
  }
`;
